module.exports = __webpack_public_path__ + "static/media/question-mark.91e92611.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/question-mark.svg
// module id = 845
// module chunks = 0